export default "/assets/images/mila-filters.05e93bdff5e88e43.webp";